import {
  MON_GEN, MON_NAME, docKey, fmtD, genDeadlines, invoiceRows, jpkDue, missingInvoices, nowYM, plural, rowsForMonth, today0, ymAdd, ymOf,
  type Data, type Settings,
} from '@biuro/shared';

export type StepState = 'ok' | 'todo' | 'late' | 'none';
export interface CloseStep {
  key: 'infakt' | 'faktury' | 'biuro';
  label: string;
  state: StepState;
  text: string;
}

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
/** „Wrzesień 2026” */
export const monthLabel = (ym: string) => `${cap(MON_NAME[+ym.slice(5) - 1])} ${ym.slice(0, 4)}`;
/** „wrzesień 2026” – w środku zdania */
export const monthLower = (ym: string) => `${MON_NAME[+ym.slice(5) - 1]} ${ym.slice(0, 4)}`;
export const monthGen = (ym: string) => `${MON_GEN[+ym.slice(5) - 1]} ${ym.slice(0, 4)}`;

/** Miesiąc do zamknięcia: poprzedni, dopóki nie minie jego termin JPK, potem bieżący (dokumenty wystawia się na koniec miesiąca). */
export function defaultCloseMonth(): string {
  const prev = ymAdd(nowYM(), -1);
  return today0() <= jpkDue(prev) ? prev : nowYM();
}

const DONE = ['created', 'found', 'manual'];

export function closeStatus(data: Data, st: Settings, m: string) {
  const t = today0();
  const active = Object.entries(data.infaktTemplates).filter(([, x]) => x.active !== false);
  const infaktOk = active.filter(([id]) => DONE.includes(data.infaktDocs[docKey(id, m)]?.status || '')).length;
  const rows = rowsForMonth(data, m);
  const drafts = invoiceRows(data).filter((x) => x.c.draft && ymOf(x.inv.issueDate) === m).length;
  const missing = missingInvoices(data, nowYM()).filter((x) => x.m === m);
  const next = ymAdd(m, 1);
  const dl = genDeadlines(st, next, next, {});
  const docsDue = dl.find((d) => d.id === `docs-${m}`)?.due || null;
  const infaktDue = genDeadlines(st, m, m, {}).find((d) => d.id === `infakt-${m}`)?.due || null;
  const sent = !!data.done[`docs-${m}`];
  const unsent = rows.filter((x) => (x.inv.status || 'new') === 'new').length;

  const steps: CloseStep[] = [];
  steps.push(active.length
    ? { key: 'infakt', label: 'Dokumenty w inFakcie', state: infaktOk === active.length ? 'ok' : infaktDue && t > infaktDue ? 'late' : 'todo', text: infaktOk === active.length ? 'gotowe' : `${infaktOk} z ${active.length}` }
    : { key: 'infakt', label: 'Dokumenty w inFakcie', state: 'none', text: 'brak szablonów' });
  const gaps = missing.length + drafts;
  steps.push({
    key: 'faktury', label: 'Faktury zagraniczne',
    state: gaps ? 'todo' : rows.length ? 'ok' : 'none',
    text: gaps
      ? [missing.length ? `brakuje ${missing.length}` : '', drafts ? `${drafts} do uzupełnienia` : ''].filter(Boolean).join(', ')
      : rows.length ? `${rows.length} ${plural(rows.length, 'faktura', 'faktury', 'faktur')}` : 'brak faktur',
  });
  steps.push({
    key: 'biuro', label: 'Wysyłka do biura',
    state: sent ? 'ok' : docsDue && t > docsDue ? 'late' : 'todo',
    text: sent ? 'wysłane' : docsDue ? `do ${fmtD(docsDue)}` : 'do wysłania',
  });
  return { steps, active, infaktOk, rows, drafts, missing, docsDue, infaktDue, sent, unsent, jpk: jpkDue(m) };
}
